import React, { useState } from "react";
import { Link } from "react-router-dom";
import db, { auth } from "../firebase";
import { useHistory } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";
import { notify } from "react-notify-toast";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setloading] = useState(false);
  const history = useHistory();
  const loadData = async (id, role) => {
    if (role === "Branch") {
      let doc = await db.collection("Branches").doc(id).get();
      let required = {
        branchName: doc.data().branchName,
        branchId: doc.data().branchId,
      };

      return required;
    } else if (role === "Merchant") {
      let doc = await db.collection("Merchant").doc(id).get();
      return doc.data();
    }
  };
  const loginHandler = async () => {
    setloading(true);
    let users = await db.collection("users").where("user", "==", false).get();

    if (users.empty) {
      setloading(false);
      notify.show("Cant find your email", "warning");
      return;
    }
    users.forEach(async (user) => {
      if (
        user.data().email === email ||
        (user.data().password === password && user.data().role)
      ) {
        let payload = await loadData(user.data().of, user.data().role);
        let data;

        if (user.data().role === "Branch") {
          data = { ...user.data(), ...payload };
          localStorage.setItem("Ubytes", JSON.stringify(data));
        } else if ("Merchant") {
          data = { ...user.data(), ...payload };
          localStorage.setItem("Ubytes", JSON.stringify(data));
        }

        setloading(false);
        notify.show("Log in successful!", "success");
        window.location = window.origin + "/dashboard";

        return;
      }
    });
    //notify.show("Can't Log you in", "error");
  };

  return (
    <div className="login-main">
      <div className="login-body">
        <div className="login-branding">
          <i
            class="fas fa-hamburger"
            style={{ color: "lightblue", marginRight: "10px" }}
          ></i>
          <p>uBytes</p>
        </div>
        <br></br>
        <div className="login-form-section">
          <strong>
            <p className="login-title">Welcome to uBytes</p>
          </strong>
          <br></br>
          <p style={{ fontSize: "small" }}>It's good to see you again!</p>
          <br></br>
          <p style={{ fontSize: "small" }}>
            Type your login information and we will take you to your dashboard
            right away.
          </p>
        </div>
        <div className="login-form">
          <div className="login-form-section">
            <p>Email</p>
            <input
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              placeholder="Enter Email"
              className="login-form-input"
              type="email"
            />
          </div>
          <br />
          <div className="login-form-section">
            <div>
              <p>Password</p>
            </div>
            <input
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              placeholder="Password"
              className="login-form-input"
              type="password"
            />
          </div>
          <div className="login-form-section">
            <button className="login-button" onClick={loginHandler}>
              {loading ? (
                <CircularProgress color="grey"></CircularProgress>
              ) : (
                "Login"
              )}
            </button>
          </div>
          <div className="login-form-section">
            <p style={{ textAlign: "center" }}>
              Don't have an account? <Link to="/signup">Signup now</Link>
            </p>
          </div>
        </div>
      </div>
      <div className="login-right-section"></div>
    </div>
  );
};

export default Login;
